import React, { useRef } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  CardText,
  Row,
  Col,
  Button,
} from "reactstrap";
import { useReactToPrint } from "react-to-print";
import "./idCard.css";

const IdCard = ({
  passportPhoto = "",
  fullName = "John Doe",
  idNumber = "ID-123456",
  location = "Headquarters",
  presidentName = "President Name",
  presidentSignature,
}) => {
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: `
      @page {
        size: A4 landscape;
        margin: 10mm;
      }
      @media print {
        body {
          background-color: white !important;
        }
        .id-card {
          box-shadow: none;
          border: 2px solid #003366;
          margin: 0 auto;
        }
        .no-print {
          display: none !important;
        }
      }
    `,
  });

  return (
    <div className="id-card-container">
      {/* <div className="no-print print-button-container">
        <Button color="primary" onClick={handlePrint}>
          Preview as PDF
        </Button>
      </div> */}

      <div ref={componentRef}>
        <Card className="id-card">
          <CardBody>
            <Row>
              <Col md="4" className="photo-column">
                <div className="passport-photo-container">
                  {passportPhoto ? (
                    <img
                      src={passportPhoto}
                      alt="Passport"
                      className="passport-photo"
                    />
                  ) : (
                    <div className="photo-placeholder">Passport Photo</div>
                  )}
                </div>
              </Col>
              <Col md="8">
                <CardTitle tag="h5" className="organization-title mb-3">
                  NIGERIAN ASSOCIATION OF SMALL & MEDIUM ENTERPRISES (NASME)
                </CardTitle>
                <center>
                  <CardSubtitle tag="h5" className="card-subtitle">
                    OFFICIAL ID CARD
                  </CardSubtitle>
                </center>

                <div className="card-details">
                  <div className="detail-row">
                    <span className="detail-label">Full Name:</span>
                    <span className="detail-value">{fullName}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">ID Number:</span>
                    <span className="detail-value">{idNumber}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Location:</span>
                    <span className="detail-value">{location}</span>
                  </div>
                </div>
              </Col>
            </Row>

            <div className="signature-section">
              <hr className="divider" />
              <Row>
                <Col md="6" className="signature-col">
                  {presidentSignature ? (
                    <img
                      src={presidentSignature}
                      alt="President Signature"
                      className="signature-image"
                    />
                  ) : (
                    <div className="signature-placeholder">
                      President Signature
                    </div>
                  )}
                </Col>
                <Col md="6" className="name-col">
                  <CardText className="president-name">
                    {presidentName}
                  </CardText>
                  <CardText className="president-title">President</CardText>
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default IdCard;
